export default __webpack_public_path__ + "media/images/foxes-logo-2021-af40fae29d527258d7ff3918c9e5d831.png";